<template>
  <div id="app" class="site container hfeed" style="height: auto !important">
    <HeadNav selectedLanguage="en" page="disclaimer" />

    <div id="content" class="main-wrapper" style="height: auto !important;">
<article>
<h1>Disclaimer</h1>

<h2>1. Affiliation Disclaimer</h2>
<p><strong>Not affiliated with Meta or WhatsApp:</strong> This website is not affiliated with, endorsed by, or in any way connected to WhatsApp Inc. or Meta Platforms, Inc. WhatsApp is a registered trademark of Meta Platforms, Inc. All product names, trademarks, and registered trademarks are the property of their respective owners.</p>

<h2>2. Third-Party Applications</h2>
<p>GB WhatsApp and other WhatsApp modifications ("mods") mentioned on this website are developed by independent third-party developers. These modifications are not official WhatsApp products and are not supported or endorsed by Meta.</p>

<h2>3. Risk Warning</h2>
<p>Using modified WhatsApp applications may:</p>
<ul>
<li>Violate WhatsApp's Terms of Service</li>
<li>Result in permanent account bans</li>
<li>Expose users to security risks, including malware and data breaches</li>
<li>Provide unreliable or unstable functionality</li>
</ul>

<h2>4. Educational Purposes Only</h2>
<p>All information provided on this website is for <strong>educational purposes only</strong>. We do not encourage or endorse the use of modified WhatsApp applications. Users are solely responsible for their decision to use such applications and any consequences that may arise.</p>

<h2>5. No Liability</h2>
<p>The operators of this website shall not be held liable for any damages, losses, or issues arising from the use of modified WhatsApp applications or reliance on the information provided on this website.</p>

<h2>6. Copyright</h2>
<p>All content on this website is protected by copyright laws. Unauthorized reproduction or distribution of this content is prohibited.</p>

<h2>7. External Links</h2>
<p>This website may contain links to external websites. We are not responsible for the content or privacy practices of these external sites.</p>
</article>
    </div>
  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'Disclaimer',
  data() {
    return {
      pageName: 'disclaimer',
      selectedLanguage: 'en',
    };
  },
  components: {
    HeadNav
  },
  methods: {
    goto(page) {
      this.$router.push({
        name: `${this.selectedLanguage}-${page}`
      });
    }
  },
};
</script>

<style lang="scss" scoped></style>